import React, { useContext, useEffect, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import { PaginationBody } from '@Entities/pagination'
import CowriterSearchResultsTable from '@Scenes/SongwriterScene/CowriterSearch/CowriterSearchScene/CowriterSearchResultsTable'
import SearchByParty from '@Components/Search/SearchByParty'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'

const CowriterSearch = () => {
    const { cowriterSearchPartyStore } = useContext(StoresContext)
    const [loading, setLocalLoading] = useState(false)

    const onPaginationChange = async (pagination: PaginationBody) => {
        cowriterSearchPartyStore.setCurrentPaginationPage(pagination.page ?? 1)
        await cowriterSearchPartyStore.setPageLimit(pagination.limit ?? 10)
    }

    useEffect(() => {
        setLocalLoading(true)
        cowriterSearchPartyStore.resetStore()
        cowriterSearchPartyStore.search().then(() => setLocalLoading(false))
    }, [])

    return (
        <div className="rightsholder-catalog-wrapper">
            <div className="global-container">
                <section className="cowriter-search">
                    <SearchByParty
                        searchPartyStore={cowriterSearchPartyStore}
                        renderPartyResultsTable={(onTitleClick, setLoading) =>
                            loading ? (
                                <PointPreloader />
                            ) : (
                                <CowriterSearchResultsTable
                                    data={cowriterSearchPartyStore.searchResults ?? []}
                                    onSelectWriter={onTitleClick}
                                    onPaginationChange={async (pagination) => {
                                        setLoading(true)
                                        await onPaginationChange(pagination)
                                        setLoading(false)
                                    }}
                                />
                            )
                        }
                        partyDetailsCardComponent={SearchResultPartyDetailsCard}
                    />
                </section>
            </div>
        </div>
    )
}

export default observer(CowriterSearch)
